import { Stack, useTheme } from '@mui/material';
import React from 'react';

interface DeleteGroupOptionProps {
  isSelected: boolean;
}

const DeleteGroupOption: React.FC<React.PropsWithChildren<DeleteGroupOptionProps>> = ({ isSelected, children }) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        p: 2,
        gap: 1,
        borderRadius: 1,
        backgroundColor: isSelected ? theme.custom.status.primary.selected : undefined,
        border: `1px solid ${isSelected ? theme.palette.primary.main : theme.custom.borderAndDivider.default}`
      }}
    >
      {children}
    </Stack>
  );
};

export default DeleteGroupOption;
